import { EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var HelpDialogComponent = (function () {
    function HelpDialogComponent(dialogRef, data, router, translateService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.router = router;
        this.translateService = translateService;
        this.onSelect = new EventEmitter();
    }
    HelpDialogComponent.prototype.closeHelpDialog = function () {
        this.onSelect.emit();
        this.closeDialog();
    };
    HelpDialogComponent.prototype.closeDialog = function (result) {
        this.dialogRef.close(result);
    };
    HelpDialogComponent.prototype.navigateAchievementDetails = function () {
        this.closeHelpDialog();
        this.router.navigate(['stats']).then();
    };
    return HelpDialogComponent;
}());
export { HelpDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/help-dialog/help-dialog.component.ts.pre-build-optimizer.js